<div class="wrapper">
  <div
    class="side side-host"
    [class.side-blue]="coinflip().host.side === 1"
    [class.side-red]="coinflip().host.side === 2"
  >
    <app-cf-player-side
      [showAnimation]="isStartedAnimation()"
      [coinflip]="coinflip()"
      [bet]="coinflip().host"
      [isHost]="true"
    ></app-cf-player-side>
  </div>
  <app-cf-middle
    class="coin"
    [showAnimation]="showAnimation()"
    [coinflip]="coinflip()"
  ></app-cf-middle>
  <div
    class="side side-part"
    [class.side-red]="coinflip().host.side === 1"
    [class.side-blue]="coinflip().host.side === 2"
  >
    <app-cf-player-side
      [showAnimation]="isStartedAnimation()"
      [coinflip]="coinflip()"
      [bet]="coinflip().part"
      [isHost]="false"
    ></app-cf-player-side>
  </div>
</div>
<div class="bottom box-white-04">
  <div class="identifiers">
    <p
      class="gameid typography-small"
      (click)="clipboardService.copy(coinflip().gameid, 'GameID copied!')"
    >
      GameID:
      <span class="typography-small">
        {{ coinflip().gameid }}
      </span>
    </p>
    <p
      class="hash typography-small"
      (click)="clipboardService.copy(coinflip().hash, 'Hash copied!')"
    >
      Hash: <span class="typography-small">{{ coinflip().hash }}</span>
    </p>
  </div>
  <div
    class="badges"
    [class.content-end]="!coinflip().is_pure"
    [class.content-between]="coinflip().is_pure"
  >
    @if (coinflip().is_pure) {
    <a
      class="button button--style-primary rounded-4 padding-x-8 rounded-4 h-20 pures-only"
    >
      <app-balance-icon
        [balance]="'pure'"
        color="var(--yellow)"
        [size]="'12px'"
      ></app-balance-icon>
      Pure items only
    </a>
    }
    <app-fairness-button
      [href]="'/provably-fair/coinflip/' + coinflip().gameid"
    ></app-fairness-button>
  </div>
</div>
